/* eslint-disable no-undef */
export const pages = [
    {
        text: 'Destinos',
        url: '/destinos'
    },
    {
        text: 'Guías de viaje',
        url: '/guias'
    }
]

const mountainTours = [
    {
        imageUrl: 'images/apalaches.jpg',
        ivaIncluded: true,
        location: 'Georgia, Estados Unidos',
        path: '/destinos',
        price: 150.5,
        rate: 9.2,
        reviews: {
            state: 'Notable',
            number: 253
        },
        title: 'Sendero de los Apalaches'
    },
    {
        imageUrl: 'images/fimmvorouhals.jpg',
        ivaIncluded: true,
        location: 'Islandia',
        path: '/destinos',
        price: 150.5,
        rate: 8.9,
        reviews: {
            state: 'Notable',
            number: 253
        },
        title: 'Paso de Fimmvörðuháls'
    },
    {
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        location: 'Hawái, Estados Unidos',
        price: 150.5,
        path: '/destinos',
        rate: 9,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        title: 'Sendero Kalalau y gastronomía local'
    }
]

const cityTours = [
    {
        imageUrl: 'images/apalaches.jpg',
        ivaIncluded: true,
        location: 'Estambul, Turquía',
        path: '/destinos',
        price: 150.5,
        rate: 7.4,
        reviews: {
            state: 'Notable',
            number: 253
        },
        title: 'Estambul nocturno: Sofía y la Mezquita Azul'
    },
    {
        imageUrl: 'images/fimmvorouhals.jpg',
        ivaIncluded: true,
        location: 'Fez, Marruecos',
        path: '/destinos',
        price: 150.5,
        rate: 8.9,
        reviews: {
            state: 'Notable',
            number: 253
        },
        title: 'Descubre el mercado de especias en Fez'
    },
    {
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        location: 'París, Francia',
        path: '/destinos',
        price: 150.5,
        rate: 9,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        title: 'Grandes museos de París: Pintura y antigüedad'
    }
]

export const dataCarousel = {
    title1: 'Testimonios',
    title2: 'Lo que opinan nuestros clientes',
    text: `Nuestro mayor activo es la satisfacción de nuestros clientes.`,
    reviews: [
        {
            nameCharacters: 'AS',
            rating: 5,
            title: 'Museo del Prado Private Guided Tour',
            text: 'Fantastic tour option! Our guides were and so knowledgeable! Made the entire tour interesting and learned so much throughout. Highly recommend!',
            date: '28/03/2024'
        },
        {
            nameCharacters: 'DS',
            rating: 4,
            title: 'Park Guell and Sagrada Familia Private Tour',
            text: `Best tour guide in Barcelona I had an incredible experience with my tour guide
in Barcelona. Her extensive knowledge brought the city to life, making every
detail fascinating. The tour was not only informative but also enjoyable, creating
lasting memories. The personalized, private tour added a special touch, and I
highly recommend her to anyone visiting Barcelona.`,
            date: '02/02/2024'
        },
        {
            nameCharacters: 'FS',
            rating: 4,
            title: 'Alcazar and Cathedral of Seville Private Tour',
            text: `Excelente experiencia!! Excelente visita. Nosso guia Hector nos deu muitas
informações interessantes demonstrando ter muito conhecimento da história da
cidade.`,
            date: '03/05/2024'
        },
        {
            nameCharacters: 'HS',
            rating: 5,
            title: 'Madrid Royal Palace Private Tour',
            text: `The tour was very nice the guide gave thorough information with the tour and he
was very kind. Excellent tour guide Robin/Ruben.`,
            date: '03/04/2024'
        },
        {
            nameCharacters: 'GS',
            rating: 4,
            title: 'Chapultepec Castle and Anthropology Museum Tour',
            text: `The Anthropology Museum was amazing, even for me—someone with very little
background in the indigenous cultures of Mexico. That&#39;s due in large part to our
guide, Emanuel, who helped piece together thousands of years of history in a
three-hour tour. He led us through three rooms covering the Mexica; the

Zapotec and Mixtec of Oaxaca; and the Maya. Most rooms include signage in
Spanish and English, but individual items are often only described in Spanish.
Thanks to our guide, I came out knowing more about the cultures of
Mesoamerica. I definitely want to explore other parts of the museum on my next
visit. After the museum, we walked to the Chapultepec Castle, where the
highlights included some interesting murals chronicling Mexican history from the
19th and early 20th centuries and a great view of the city. Thanks again,
Emanuel!`,
            date: '26/05/2024'
        },
        {
            nameCharacters: 'KS',
            rating: 5,
            title: 'Private Full-Day Teotihuacan Archaeological Tour:',
            text: `We enjoyed our trip with Manuel and Abraham to the Teotihuacan. Manuel was
our guide. Abraham was our driver. Manuel is very knowledgeable. We asked
him many questions and enjoyed learning from him. He has a degree in Mayan
linguistics and is generally interested in history. He participates in seminars to
increase and update his understanding of the current archaeological findings. If
you go alone and rely upon the signage, you&#39;ll be learning dated information as
the signage hasn&#39;t been revised since the 1970&#39;s. He has a good command of
the English language.`,
            date: '03/01/2024'
        }
    ],
    footer: {
        title: '¿Necesitas ayuda?',
        text: 'Cuenta con nuestro equipo todos los días de la semana, de lunes a domingo.',
        buttonLabel: 'Contacta con Trekzy',
        buttonUrl: 'quienes-somos#contacto'
    }
}

export const getCardsByTours = (name) => {
    switch (name) {
        case 'Montaña':
            return [...mountainTours, ...mountainTours]
        case 'Ciudad':
            return [...cityTours, ...cityTours]
        default:
            return [...mountainTours, ...cityTours]
    }
}

export const recomendedTours = [
    {
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        languages: null,
        time: null,
        cancelable: false,
        rate: 8.2,
        price: 150.5,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        description: `Lorem ipsum dolor sit amet consectetur. Aliquet amet in proin nibh. 
            Habitasse metus quis at est platea sem venenatis pellentesque. Commodo velit nisl
            diam magnis massa volutpa.`,
        title: 'Sendero Kalalau y gastronomía local',
        date: '10 de junio de 2024',
        type: 'Paquete premium(150€)',
        assistants: '1 adulto, 3 ninos',
        moreDetails: false,
        edit: true,
        remove: true
    },
    {
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        languages: 'Ingles',
        time: 'De 4 a 5 horas',
        cancelable: true,
        rate: 9,
        price: 150.5,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        description: `Lorem ipsum dolor sit amet consectetur. Aliquet amet in proin nibh. 
            Habitasse metus quis at est platea sem venenatis pellentesque. Commodo velit nisl
            diam magnis massa volutpa.`,
        title: 'Sendero Kalalau y gastronomía local',
        moreDetails: true,
        edit: false,
        remove: false
    },
    {
        imageUrl: 'images/kalalau.jpg',
        ivaIncluded: true,
        languages: 'Ingles y Espanol',
        time: 'De 4 a 5 horas',
        cancelable: true,
        rate: 9,
        price: 150.5,
        reviews: {
            state: 'Excelente',
            number: 9378
        },
        description: `Lorem ipsum dolor sit amet consectetur. Aliquet amet in proin nibh. 
            Habitasse metus quis at est platea sem venenatis pellentesque. Commodo velit nisl
            diam magnis massa volutpa.`,
        title: 'Sendero Kalalau y gastronomía local',
        moreDetails: true,
        edit: false,
        remove: false
    }
]

export const predictions = {
    destinos: [
        {
            name: 'Madrid',
            path: '/destinos/espana/madrid'
        },
        {
            name: 'Madagascar',
            path: '/destinos/australia/madagascar'
        },
        {
            name: 'Paris',
            path: '/destinos/francia/paris'
        },
        {
            name: 'Barcelona',
            path: '/destinos/espana/barcelona'
        }
    ],
    tours: [
        {
            name: 'Museos Madrid',
            path: '/destinos/espana/madrid/museos-madrid'
        },
        {
            name: 'Snorkel Madagascar',
            path: '/destinos/australia/madagascar/snorkel-madagascar'
        },
        {
            name: 'Museos Paris',
            path: '/destinos/francia/paris/museos-paris'
        },
        {
            name: 'Museos Barcelona',
            path: '/destinos/espana/barcelona/museos-barcelona'
        }
    ]
}

export const getMockSuggestions = (value) => {
    let sugerencias = []
    const destinos = predictions.destinos.filter((destino) =>
        destino.name.toLowerCase().includes(value.toLowerCase())
    )
    const tours = predictions.tours.filter((tour) =>
        tour.name.toLowerCase().includes(value.toLowerCase())
    )

    if (!destinos.length && !tours.length && value.length > 1) {
        const _destinos = predictions.destinos.filter((destino) =>
            destino.name.toLowerCase().includes(value[0].toLowerCase())
        )
        const _tours = predictions.tours.filter((tour) =>
            tour.name.toLowerCase().includes(value[0].toLowerCase())
        )

        sugerencias = [..._destinos, ..._tours]
    }

    return {
        Destinos: destinos,
        Tours: tours,
        sugerencias
    }
}
